import React, {useContext} from 'react';

import {VisibilityContext} from 'react-horizontal-scrolling-menu';
import { Typography } from '@mui/material';

import RightArrowIcon from '../../assets/icons/right-arrow.png';

const RightArrow = () => {
   const { scrollNext } = useContext(VisibilityContext)
    return (
        <Typography
            onClick={() => scrollNext()}
            className="left-arrow"
        >
            <img src={RightArrowIcon} alt="Right Arrow Icon"/>
        </Typography>
    )
}

export default RightArrow
